import React from "react";

function Navbar({ onHome, onListings, onFeatured, onAbout, onContact }) {
  // ✅ Helper to close the collapse after click
  const closeNavbar = () => {
    const navbar = document.getElementById("publicNavbar");
    if (navbar && navbar.classList.contains("show")) {
      const collapse = window.bootstrap.Collapse.getInstance(navbar);
      if (collapse) collapse.hide();
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container-fluid">
        {/* Brand */}
        <a
          className="navbar-brand"
          href="/"
          onClick={(e) => {
            e.preventDefault();
            onHome();
            closeNavbar();
          }}
        >
          Barbara PH Properties
        </a>

        {/* Toggler for mobile */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#publicNavbar"
          aria-controls="publicNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible links */}
        <div className="collapse navbar-collapse" id="publicNavbar">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a
                className="nav-link"
                href="#home"
                onClick={(e) => {
                  e.preventDefault();
                  onHome();
                  closeNavbar();
                }}
              >
                Home
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#listings"
                onClick={(e) => {
                  e.preventDefault();
                  onListings();
                  closeNavbar();
                }}
              >
                Listings
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#featured"
                onClick={(e) => {
                  e.preventDefault();
                  onFeatured();
                  closeNavbar();
                }}
              >
                Featured
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  onAbout();
                  closeNavbar();
                }}
              >
                About
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  onContact();
                  closeNavbar();
                }}
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
